import React from 'react';

const Header = () => {
     return (
          <div className="h-[40px]">
               <p className="text-center text-xs font-poppins py-3 font-light">Change your perspective</p>
          </div>
     );
}

export default Header;